import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {Button, Col, Input} from "reactstrap";
import {Link, Redirect} from "react-router-dom";
import {Trans, useTranslation} from "react-i18next";
import get from 'lodash/get';

import {createViberBot} from "../../../thunks/Connect";
import {renderErrorsAsHTML} from "../../../Components/utils";
import {clearErrors} from "../../../actions/Connect";


const ViberBot = (
    {
        activeShop,
        errors,
        isSendingRequest,
        createViberBot,
        clearErrors,
    }
) => {
    const {t, i18n} = useTranslation();

    const [viberURI, setViberURI] = useState(undefined);
    const [viberToken, setViberToken] = useState(undefined);
    const [redirectTo, setRedirectTo] = useState(undefined);

    // ComponentDidMount
    useEffect(() => {
        clearErrors();
    }, []);

    const dashboardUrl = `/${activeShop.id}/dashboard`;

    const onButtonClick = (event) => {
        createViberBot(
            activeShop.id,
            'Viber Bot',
            viberURI,
            viberToken,
            (result) => setRedirectTo(dashboardUrl),
        );
    };

    if (redirectTo) {
        return <Redirect to={redirectTo}/>
    }

    return <div className="d-flex justify-content-center align-items-center">
        <Col md="8" className="mx-auto app-login-box">
            <div className="modal-dialog w-100 mx-auto">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="app-header__logo w-100 justify-content-center">
                            <div className="logo-src"/>
                        </div>

                        <div className="h5 modal-title text-center">
                            <h4 className="mt-4">
                                <div>
                                    {t('connect_card.viber.title', 'Connect Viber bot')}
                                </div>

                                <div className='font-size-md mt-4 opacity-10'>
                                    {t('connect_card.viber.caption', "Viber bot's URL & token:")}
                                </div>
                            </h4>
                        </div>

                        <div className='d-flex flex-column justify-content-center mb-3'>
                            <Input
                                placeholder="Uri"
                                value={viberURI}
                                onChange={(event) => setViberURI(event.target.value)}
                            />
                            <small className="text-danger mt-1">{get(errors, 'viber_bot_uri')}</small>
                        </div>
                        <div className='d-flex flex-column justify-content-center my-3'>
                            <Input
                                placeholder="Token"
                                value={viberToken}
                                onChange={(event) => setViberToken(event.target.value)}
                            />
                            <small className="text-danger mt-1">{get(errors, 'viber_bot_token')}</small>
                        </div>
                        <div className='d-flex justify-content-center my-3'>
                            <Button
                                color='primary'
                                onClick={onButtonClick}
                                disabled={isSendingRequest}
                            >
                                {t('connect_bot.common.submit', 'Connect')}
                            </Button>
                        </div>

                        <div className="text-center text-danger">
                            {renderErrorsAsHTML(errors)}
                        </div>

                        <div className='modal-body font-size-md mt-4'>
                            <h5 className='text-center mb-3'>
                                <a rel="noopener noreferrer" href={t('connect_bot.viber.url_help', 'https://help.chat-api.com/ru/vizual_nyj_konstruktor_chat_botov/viber_sozdanie_chatbota')} target='_blank'>
                                    📕 {t('connect_bot.common.title_help', 'Detailed instructions')}
                                </a>
                            </h5>

                            <ol>
                                <Trans t={t} i18nKey='connect_bot.viber.instruction'>
                                    <li className='mb-3'>
                                        Переходим на сайт разработки:{' '}
                                        <a rel="noopener noreferrer" href="https://partners.viber.com/" target='_blank'>partners.viber.com</a>.
                                        <br/>
                                        Предварительно у вас должно быть установлено приложение Viber.
                                    </li>
                                    <li className='mb-3'>
                                        Вводим номер телефона и авторизуемся
                                    </li>
                                    <li className='mb-3'>
                                        Viber пришлёт код подтверждения, вводим его, нажимаем «Дальше».
                                    </li>
                                    <li className='mb-3'>
                                        Нажимаем кнопку «Создать бот» и заполняем необходимые поля. Описание полей см. в{' '}
                                        <a rel="noopener noreferrer" href="https://help.chat-api.com/ru/vizual_nyj_konstruktor_chat_botov/viber_sozdanie_chatbota" target='_blank'>документации</a>
                                    </li>
                                    <li className='mb-3'>
                                        Внизу ставим галочку о принятии соглашения и нажимаем «Create».{' '}
                                    </li>
                                    <li className='mb-3'>
                                        После этого вы получите токен для аутентификации Viber. Скопируйте его и вставьте в поле выше.
                                    </li>
                                </Trans>
                            </ol>
                        </div>
                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <Link to={dashboardUrl} className="btn-lg btn btn-link">
                            {t('connect_bot.common.back_to_bot_list', 'Back to bots list')}
                        </Link>
                    </div>
                </div>
            </div>
        </Col>
    </div>;
};


const mapStateToProps = state => ({
    activeShop: state.Shops.activeShop,
    errors: state.Connect.errors,
    isSendingRequest: state.Connect.isSendingRequest,
});

const mapDispatchToProps = dispatch => ({
    createViberBot: (shop_id, name, viber_bot_uri, viber_bot_token, callback) => dispatch(createViberBot(shop_id, name, viber_bot_uri, viber_bot_token, callback)),
    clearErrors: () => dispatch(clearErrors()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViberBot);
